export const EMPTY_MEMBER_CONTACT_VALUE = '--';
export const MEMBER_CONTACT_EDIT_LABEL = 'Edit';
export const MEMBER_CONTACT_SECTION_TITLE = 'Member Information';
